import { Map, Record } from 'immutable';

export default class Action extends Record({
  name: '',
  defaultArgs: Map(),
  defaultLet: undefined,
}) {}
